import type { IconData } from '@stacksjs/iconify-core'

export const sortAscending: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m43.314 130.51l51.882-51.883v417.569h32V78.627l51.883 51.883l22.627-22.627l-90.51-90.511l-90.51 90.511z\"/><path fill=\"currentColor\" d=\"M184 160h120v32H184zm0 72h184v32H184zm0 72h248v32H184zm0 72h312v32H184z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default sortAscending
